"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iWorksiteDiaryJobRevision = void 0;
const t = require("io-ts");
const _iWorksiteDiaryJobRevision = t.intersection([
    t.interface({
        status: t.union([t.literal('STARTED'), t.literal('ON_HOLD'), t.literal('IN_PROGRESS'), t.literal('DONE')]),
        notes: t.string
    }),
    t.partial({
        updated_at: t.number,
        id: t.number,
        uuid: t.string,
        entry_uuid: t.string,
        deleted_at: t.number,
    })
]);
exports.iWorksiteDiaryJobRevision = t.clean(_iWorksiteDiaryJobRevision);
//# sourceMappingURL=worksiteDiaryJobRevision.js.map